module.exports = __webpack_public_path__ + "img/visa.82726b92.svg";